import api from "../services/baseapi";
import store from "../redux/Store";
import {top} from "../redux/reducers/messagesSlice";
import reactStringReplace from "react-string-replace";
import {Link} from "react-router-dom";
import React from "react";
import {useSelector} from "react-redux";
import { setCredentials } from "./CommonHelper";

const create = async (path, params = {}) => {
    const response = await api.post(path, {...params});
    return response.data
}

const viewDetails = async (path, selectById, id, options = {from_cache: true}) => {
    // console.log("Cache: ", options.from_cache)
    try {
        if (options.from_cache) {
            const state = store.getState();
            const row = selectById(state, id)
            if (Object.keys(row).length > 0) {
                return row;
            }
        }
        const response = await api.get(path);
        return response.data
    } catch (e) {
        // console.log(e)
        return {}
    }
}
const prepParams = (params) => {
    // console.log(params)
    const _params = {...params}
    try {
        if (_params['hasQueryUpdate']) {
            // console.log(_params)
            _params.shouldQuery = true;
            _params['pageNo'] = 1
            _params['page'] = 0
        }
        Object.keys(_params).map(key => {
            _params[key] = String(_params[key]).trim()
            // console.log(params[key], String(params[key]).length, _params[key].length)
            if (_params[key] === '') {
                delete _params[key]
            }
        })
    } catch (e) {
        // console.log(e)
    }
    return _params
}

const search = async (path, params = {}) => {
    const _params = prepParams(params)
    const response = await api.get(path, {params: _params});
    return response.data
}

const searchHeader = async (path, params = {}) => {
    const _params = prepParams(params)
    const response = await api.get(path, {params: _params});
    return {content: response.data}
}

const searchPage = async (path, params = {}) => {
    // console.log(params)
    const _params = prepParams(params)
    _params['pageNo'] = parseInt(_params['page']) + 1
    let data = {}
    if (_params.shouldQuery) {
        const response = await api.get(path, {params: _params});
        data = {
            content: response.data.page.currentItems,
            size: response.data.page.pageSize,
            totalElements: response.data.totalItems,
            totalPages: response.data.totalPages,
            empty: response.data.page.numberOfElements === 0,
            number: parseInt(response.data.page.currentPage) - 1
        }
    }
    return data
}

const deleteApi = async (path, params = {}) => {
    const _params = prepParams(params)
    const response = await api.delete(path, {params: _params});
    return {content: response.data}
}

const pending = state => {
    state.status = 'pending'
}
const idle = state => {
    state.status = 'idle'
}

const saveParams = (state, action) => {
    // console.log("params: ", action.payload)
    state.params = action.payload
}

const saveAddFields = (state, action) => {
    // console.log('saveAddFields', action.payload)
    state.addFields = action.payload
}

const saveRequest = (state, action) => {
    // console.log('saveRequest', action.payload)
    state.request = action.payload
}

const createResponse = (state, action) => {
    // console.log(action.payload)
    state.status = 'idle'
    state.saveResponse = action.payload
}

const deleteResponse = (state, action) => {
    // console.log(action.payload)
    state.status = 'idle'
    state.deleteResponse = action.payload
}


const searchResponse = (state, action) => {
    // console.log(action.payload)
    state.status = 'idle'
    state.params.hasQueryUpdate = false
    state.params.shouldQuery = false
    state.params.pageSize = action.payload.size
    state.params.totalPages = action.payload.totalPages
    state.params.page = action.payload.empty ? 0 : action.payload.number + 1
    state.params.totalElements = action.payload.totalElements
    if (action.payload.empty == false) {
        // console.log(state.params.totalElements, state.params.page, state.params.pageSize)
        const start = state.params.totalElements - (state.params.page - 1) * state.params.pageSize;
        action.payload.content.map((row, i) => {
            // console.log(start, i)
            row['_serial'] = start - i;
        })
    }
    state.content = action.payload.content
}

const viewResponse = (state, action) => {
    state.status = "idle"
    // console.log("State: ", JSON.stringify(state))
    // console.log("Action: ", action)
    const actionPayload = action.payload.content ? {...action.payload.content[0]} : {...action.payload}
    const index = state.content.findIndex(item => item.id === actionPayload.id);
    if (index !== -1) {
        actionPayload['_serial'] = state.content[index]['_serial']
        state.content[index] = actionPayload
        return
    }
    if (state.content.length !== 0) {
        actionPayload['_serial'] = state.content[0]['_serial'] + 1
        state.content.push({...actionPayload})
        return;
    }
    state.content.push({...actionPayload, '_serial': 1})
}

const update = async (path, params = {}, options = {}) => {
    const response = await api.put(path, params);
    return {...response.data, _options: {...options}}
}
const updateResponse = (state, action) => {
    // console.log("State before push: ", JSON.stringify(state))
    // console.log("Action fulfilled: ", action)
    state.status = "idle"

    const updated = {...action.payload}
    const key = updated._options?.key || 'id'
    // console.log(key)
    const index = state.content.findIndex(item => item[key] === updated[key]);
    try {
        delete updated['_options']
    } catch (e) {
        // console.log(e)
    }
    if (index !== -1) {
        updated['_serial'] = state.content[index]['_serial']
        state.content[index] = updated
        return
    } else {
        // state.content.push(updated)
    }
}

const login = async (path, params = {}) => {
    const response = await api.post(path, {...params});
    console.log("LOGIN RESPONSE",response)
    return {
        ...response.data,
        'X-KM-Access-Token': response.headers['x-km-access-token'],
        'X-KM-Refresh-Token': response.headers['x-km-refresh-token'],
        // 'x-km-correlation-id': response.headers['x-km-correlation-id'],
    }
}

const loginResponse = (state, action) => {
    state.status = 'idle'
    // console.log("payload: ", action.payload)
    state.credentials = action.payload;
    setCredentials(action.payload);
}

const logout = async (path, params= {}) => {
    const response = await api.post(path);
    return response.data
}

const logoutResponse = (state, action) => {
    state.status = 'idle'
}

const validate = async (path, params = {}) => {
    const response = await api.post(path, {...params});
    // console.log("response: ", response)
    return response.data
}

const validateResponse = (state, action) => {
    state.status = 'idle'
    // console.log("Action: ", action)
}

const recover = async (path, params = {}) => {
    const response = await api.post(path, {...params});
    // console.log("response: ", response)
    return response.data
}

const recoverResponse = (state, action) => {
    state.status = 'idle'
    // console.log("Action: ", action)
}

const subscribe = async ({fn, validate, interval, maxAttempts}) => {
    let attempts = 0;

    const execute = async (resolve, reject) => {
        const result = await fn();
        attempts++
        if (validate(result)) {
            return resolve(result)
        } else if (maxAttempts && attempts === maxAttempts) {
            return reject(new Error("Exceeded max attempts"))
        } else {
            setTimeout(execute, interval, resolve, reject)
        }
    }

    return new Promise(execute);
}

const validateJobStatus = (jobStatus) => ['SUCCESS', 'DONE'].includes(jobStatus)

const subscribeForJobStatus = (jobId) => subscribe({
    fn: () => viewDetails(`/ldtps/api/job/status?jobId=${jobId}`, {}, {}, {from_cache: false}),
    validate: validateJobStatus,
    interval: 20000,
    maxAttempts: 4
}).then(() => {
    store.dispatch(top({
        server: {
            message: reactStringReplace('Job Id ' + jobId + ' completed successfully', jobId,
                (match, i) => (<Link key={i} to={`/dashboard/data-tampering-protection/${jobId}`}>{match}</Link>))
        }
    }))
}).catch(() => store.dispatch(top({
    server: {
        message: reactStringReplace('Job Id ' + jobId + ' failed', jobId,
            (match, i) => (<Link key={i} to={`/dashboard/data-tempering-protection/${jobId}`}>{match}</Link>))
    }
})))

const queryParam = (search, param) => {
    const urlParams = new URLSearchParams(search)
    return urlParams.get(param)
}

const getComponent = (search, params, node = 'c') => {
    // console.log(search, params, node)
    // const component = queryParam(search, node);
    // return component ? component : params.component;
    return params.component;
}

const getBaseUrl = (contextPath, path) => {
    // console.log("context: ", contextPath)
    return '/' + contextPath + path;
};

export const ApiHelper = {
    search,
    searchHeader,
    searchPage,
    pending,
    idle,
    searchResponse,
    saveParams,
    createResponse,
    create,
    saveAddFields,
    viewDetails,
    viewResponse,
    update,
    updateResponse,
    deleteApi,
    deleteResponse,
    saveRequest,
    login,
    validateResponse,
    validate,
    recover,
    recoverResponse,
    subscribeForJobStatus,
    // queryParam,
    getComponent,
    getBaseUrl,
    loginResponse,
    logout,
    logoutResponse
}